import React from "react";
import PropTypes from "prop-types";
import { BsDownload as BsDownloadIcon } from "react-icons/bs";

import DocumentsImage from "../../../../assets/images/empresarial/documents.png";
import { ButtonLinkStyled } from "../../../../components/common/Buttons/Button.Style";

import * as S from "./DocumentsSection.style";

const DocumentsSection = ({ documentType, documentList }) => {
  const handleClick = (url) => {
    if (!url) {
      return;
    }

    window.open(url);
  };

  return (
    <S.DocumentsSectionContainer>
      <S.DocumentsSectionContent className="container">
        <S.DocumentsSectionImage
          src={DocumentsImage}
          alt="Ícone de localização sobre um mapa estilizado em tons de azul"
          width="336px"
          height="336px"
        />

        <S.DocumentsSectionBlock>
          <S.DocumentsSectionBlockTitle>
            Documentos
          </S.DocumentsSectionBlockTitle>

          <S.DocumentsSectionBlockDescription>
            Baixe os arquivos e conheça mais sobre o {documentType || ""}!
          </S.DocumentsSectionBlockDescription>

          <S.DocumentsSectionLinkList>
            {Array.isArray(documentList)
              ? documentList.map((document) => (
                  <ButtonLinkStyled
                    key={document.id}
                    onClick={() => handleClick(document.href)}
                  >
                    <BsDownloadIcon size={24} />
                    <span>{document.label}</span>
                  </ButtonLinkStyled>
                ))
              : null}
          </S.DocumentsSectionLinkList>
        </S.DocumentsSectionBlock>
      </S.DocumentsSectionContent>
    </S.DocumentsSectionContainer>
  );
};

DocumentsSection.propTypes = {
  documentType: PropTypes.string,
  documentList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
    })
  ),
};

DocumentsSection.defaultProps = {
  documentType: "",
  documentList: [],
};

export default DocumentsSection;
